import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

const isFilterDescriptor = (
  filter: CompositeFilterDescriptor | FilterDescriptor
): filter is FilterDescriptor => !('filters' in filter);

/** Matches Kendo "Is null or empty" for client-side grids whose mappers coerce null to ''. */
export const isNullOrEmptyValue = (value: unknown): boolean => value == null || value === '';

export const isNotNullOrEmptyValue = (value: unknown): boolean => !isNullOrEmptyValue(value);

export const normalizeNullOrEmptyFilters = (
  filter?: CompositeFilterDescriptor
): CompositeFilterDescriptor | undefined => {
  if (!filter) {
    return filter;
  }

  return {
    ...filter,
    filters: filter.filters.map((item) => {
      if (!isFilterDescriptor(item)) {
        return normalizeNullOrEmptyFilters(item) ?? item;
      }

      if (item.operator === 'isnull') {
        return { ...item, operator: isNullOrEmptyValue };
      }

      if (item.operator === 'isnotnull') {
        return { ...item, operator: isNotNullOrEmptyValue };
      }

      return item;
    }),
  };
};
